// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search-bar {
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.search-form {
  display: flex;
  gap: 10px;
  align-items: center;
}

.search-input {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  font-size: 16px;
  transition: border-color 0.3s ease;
  outline: none;
}

.search-input:focus {
  border-color: #667eea;
}

.search-input::placeholder {
  color: #adb5bd;
}

.search-buttons {
  display: flex;
  gap: 10px;
}

.search-button,
.clear-button {
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.search-button {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.search-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);
}

.clear-button {
  background-color: #e9ecef;
  color: #495057;
}

.clear-button:hover {
  background-color: #dee2e6;
}

@media (max-width: 768px) {
  .search-form {
    flex-direction: column;
  }
  
  .search-input {
    width: 100%;
  }
  
  .search-buttons {
    width: 100%;
  }
  
  .search-button,
  .clear-button {
    flex: 1 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/SearchBar.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,SAAO;EACT;AACF","sourcesContent":[".search-bar {\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.search-form {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.search-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #e9ecef;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: border-color 0.3s ease;\n  outline: none;\n}\n\n.search-input:focus {\n  border-color: #667eea;\n}\n\n.search-input::placeholder {\n  color: #adb5bd;\n}\n\n.search-buttons {\n  display: flex;\n  gap: 10px;\n}\n\n.search-button,\n.clear-button {\n  padding: 12px 24px;\n  border: none;\n  border-radius: 8px;\n  font-size: 16px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  white-space: nowrap;\n}\n\n.search-button {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.search-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(102, 126, 234, 0.4);\n}\n\n.clear-button {\n  background-color: #e9ecef;\n  color: #495057;\n}\n\n.clear-button:hover {\n  background-color: #dee2e6;\n}\n\n@media (max-width: 768px) {\n  .search-form {\n    flex-direction: column;\n  }\n  \n  .search-input {\n    width: 100%;\n  }\n  \n  .search-buttons {\n    width: 100%;\n  }\n  \n  .search-button,\n  .clear-button {\n    flex: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
